import React from 'react';

interface Props {
    currentStep: string;
    totalSteps: string;
}

const StepCounter = ({ currentStep, totalSteps }: Props): JSX.Element => (
    <div className="step-counter">
        {!!(currentStep && totalSteps) && (
            <h5>
                {currentStep}/{totalSteps}
            </h5>
        )}
    </div>
);

export default StepCounter;
